<app-navbar [useWithAuth]="false"/>
<div class="d-flex align-items-center justify-content-center w-100 h-100">
    <mat-card class="mat-elevation-z15" style="max-width: 80vw; width: 400px">
        <router-outlet></router-outlet>
    </mat-card>
</div>
<app-footer />
@if (loaderState()) {
<app-fullscreen-loader></app-fullscreen-loader>
}

